import { Routes } from '@angular/router';

export const systemConfigurationsRoutes: Routes = [
  { path: '', redirectTo: 'overview', pathMatch: 'full', data: { isNotAMenuItem: true } },
  {
    path: 'overview',
    loadComponent: () =>
      import('./config-apps/system-configs-dashboard/system-configs-dashboard').then(
        (m) => m.SystemConfigsDashboard,
      ),
    data: {
      name: 'Overview',
      icon: 'dashboard',
    },
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./config-apps/system-configs-reports/system-configs-reports').then(
        (m) => m.SystemConfigsReports,
      ),
    data: {
      name: 'Reports',
      icon: 'summarize',
    },
  },
];
